import { ApolloClient, ApolloQueryResult, NormalizedCacheObject } from '@apollo/client';
import { handleQuery } from '@99designs/graph-utils';
import { RecommendedBrandingProductsDocument } from '../graphql/Recommendation.generated';
import type { RecommendedBrandingProductsQuery } from '../graphql/Recommendation.generated';

export async function getRecommendedProducts(
    client: ApolloClient<NormalizedCacheObject>,
    names: string[]
): Promise<RecommendedBrandingProductsQuery> {
    const { data, error } = await fetchRecommendedProducts(client, names);

    if (error) {
        throw error;
    }

    return data;
}

function fetchRecommendedProducts(
    client: ApolloClient<NormalizedCacheObject>,
    names: string[]
): Promise<ApolloQueryResult<RecommendedBrandingProductsQuery>> {
    return handleQuery<RecommendedBrandingProductsQuery>(client, {
        query: RecommendedBrandingProductsDocument,
        variables: {
            input: {
                names,
            },
        },
    });
}
